// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#thank-you-message[data-v-9923cb1c] {\n    font-weight: bold;\n    background-color: var(--white);\n    padding: 10px 0 0 0;\n    text-align: center;\n}\n#thank-you-message p[data-v-9923cb1c]:nth-child(2) {\n        font-size: 18px;\n}\n#thank-you-message p[data-v-9923cb1c]:nth-child(3) {\n        font-weight: normal;\n}\n#checkmark[data-v-9923cb1c] {\n    margin: 30px auto;\n}\n", ""]);
// Exports
module.exports = exports;
